// C:\Users\phill\paperplay\frontend\src\features\accountsettings\accountSettingsEndpoints.ts

import { api } from '../../apis/endpoints/_helpers';

export const ACCOUNT_SETTINGS = {
  BASE: api('/accountsettings/'),

  // --- Profile / Auth
  USER_PROFILE_SELF: api('/accountsettings/userprofile/me/'),
  USER_PROFILE: (userId: string) => api(`/accountsettings/userprofile/${userId}/`),
  CHANGE_PASSWORD: api('/change-password/'),
  FORGOT_PASSWORD: api('/accountsettings/forgot-password/'),

  // --- Preferences (matches your ViewSet @action url_paths)
  PREFERENCES: api('/accountsettings/preferences/settings/'),
  NOTIFICATIONS: api('/accountsettings/preferences/notifications/'),
  PRIVACY: api('/accountsettings/privacy-settings/settings/'),

  // --- Devices / 2FA / accounts / context
  AUTHORIZED_DEVICES: api('/accountsettings/authorized-devices/'),
  TWO_FACTOR: api('/accountsettings/twofactor/status/'),
  CONNECTED_ACCOUNTS: api('/accountsettings/connected-accounts/'),
  CURRENT_CONTEXT: api('/accountsettings/current-context/'),

  // --- Billing
  BILLING_HISTORY: api('/accountsettings/billing-history/'),
  SUBSCRIPTION_CURRENT: api('/accountsettings/subscriptions/current/'),
  BILLING_CHECKOUT_SESSION: api('/accountsettings/billing/checkout-session/'),
  BILLING_PORTAL_SESSION: api('/accountsettings/billing/portal-session/'),
  SUBSCRIPTION_PLANS: api('/accountsettings/plans/'),
  SUBSCRIPTION_CHANGE_PLAN: api('/accountsettings/changePlan/'),
  SUBSCRIPTION_CANCEL: api('/accountsettings/cancel/'),
  SUBSCRIPTION_APPLY_PROMO: api('/accountsettings/applyPromo/'),

  // --- Payments exposed inside Account Settings UX
  PAYMENT_METHODS: api('/payments/payment-methods/'),
  PAYMENT_METHOD_DETAIL: (id: string) => api(`/payments/payment-methods/${id}/`),

  USER_PROFILE_COLLECTION: api('/accountsettings/userprofile/'),
} as const;
